import React, { useState } from "react";
import axios from "axios";

const AdminAddCategory = () => {
  const [categoryName, setCategoryName] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent form submission reloading the page
    setLoading(true);
    setSuccessMessage("");
    setErrorMessage("");

    try {
      const token = localStorage.getItem("admin_token"); // Retrieve the token from local storage

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/categories/`,
        { category_name: categoryName }, // Payload
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // Include Bearer token
          },
        }
      );

      setSuccessMessage("Kategori başarıyla eklendi!");
      setCategoryName(""); // Reset input field
    } catch (error) {
      console.error("Error adding category:", error);
      setErrorMessage(
        error.response?.data?.detail || "Bir hata oluştu. Lütfen tekrar deneyin."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-5">
      <h5 className="mb-4">Yeni Kategori Ekle</h5>
      <form onSubmit={handleSubmit} className="needs-validation">
        <div className="mb-3">
          <input
            type="text"
            id="categoryName"
            className="form-control"
            autoComplete="false"
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
            required
            placeholder="Kategori ismini giriniz"
          />
        </div>
        <button
          type="submit"
          className="btn btn-primary"
          disabled={loading}
        >
          {loading ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Ekleniyor...
            </>
          ) : (
            "Kategori Ekle"
          )}
        </button>
      </form>

      {/* Success message */}
      {successMessage && (
        <div className="alert alert-success mt-3" role="alert">
          {successMessage}
        </div>
      )}

      {/* Error message */}
      {errorMessage && (
        <div className="alert alert-danger mt-3" role="alert">
          {errorMessage}
        </div>
      )}
    </div>
  );
};

export default AdminAddCategory;
